import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "app-review"
  static values = {
    recordUrl: String,
    delay: { type: Number, default: 10000 }
  }

  static SESSION_KEY = "floosyo:review-asked"

  connect() {
    super.connect()
  }

  requestOnce() {
    if (this.#alreadyAsked) return
    if (!this.enabled) return

    this.#markAsked()
    setTimeout(() => this.request(), this.delayValue)
  }

  request() {
    if (!this.enabled) return

    this.send("request")
    this.#recordAsk()
  }

  #recordAsk() {
    if (!this.hasRecordUrlValue || !this.recordUrlValue) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.recordUrlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": token || "", "Accept": "text/plain" },
      keepalive: true
    })
  }

  get #alreadyAsked() {
    try {
      return sessionStorage.getItem(this.constructor.SESSION_KEY) === "1"
    } catch (_) {
      return false
    }
  }

  #markAsked() {
    try {
      sessionStorage.setItem(this.constructor.SESSION_KEY, "1")
    } catch (_) { }
  }
}
